import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./BottomNavigation.css";
import { useNavigation } from "../context/NavigationContext";

const BottomNavigation: React.FC = () => {
  const { currentTab, setCurrentTab, setDirection } = useNavigation();
  const location = useLocation();

  // 현재 경로에 따라 탭 상태 업데이트
  useEffect(() => {
    const pathToTab: Record<string, string> = {
      "/": "home",
      "/talk": "talk",
      "/map": "map",
      "/chat": "chat",
      "/mypage": "mypage",
    };

    const tab = pathToTab[location.pathname];
    if (tab && tab !== currentTab) {
      setCurrentTab(tab);
    }
  }, [location.pathname, currentTab, setCurrentTab]);

  const handleTabChange = (tab: string, index: number) => {
    const tabOrder = ["home", "talk", "map", "chat", "mypage"];
    const currentIndex = tabOrder.indexOf(currentTab);

    // 현재 탭과 클릭한 탭의 인덱스를 비교하여 방향 결정
    if (index > currentIndex) {
      setDirection("left"); // 오른쪽에서 왼쪽으로 스와이프
    } else if (index < currentIndex) {
      setDirection("right"); // 왼쪽에서 오른쪽으로 스와이프
    } else {
      setDirection("none"); // 같은 탭 클릭 시 애니메이션 없음
    }

    setCurrentTab(tab);
  };

  return (
    <div className="bottom-navigation">
      <Link
        to="/"
        className={`nav-item ${location.pathname === "/" ? "active" : ""}`}
        onClick={() => handleTabChange("home", 0)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            location.pathname === "/"
              ? "bottom-home-active.svg"
              : "bottom-home.svg"
          }`}
          alt="홈"
          className="nav-icon"
        />
      </Link>

      <Link
        to="/talk"
        className={`nav-item ${location.pathname === "/talk" ? "active" : ""}`}
        onClick={() => handleTabChange("talk", 1)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            location.pathname === "/talk"
              ? "bottom-talk-active.svg"
              : "bottom-talk.svg"
          }`}
          alt="펫톡"
          className="nav-icon"
        />
      </Link>

      <Link
        to="/map"
        className={`nav-item ${location.pathname === "/map" ? "active" : ""}`}
        onClick={() => handleTabChange("map", 2)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            location.pathname === "/map"
              ? "bottom-map-active.svg"
              : "bottom-map.svg"
          }`}
          alt="펫맵리스트"
          className="nav-icon"
        />
      </Link>

      <Link
        to="/chat"
        className={`nav-item ${location.pathname === "/chat" ? "active" : ""}`}
        onClick={() => handleTabChange("chat", 3)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            location.pathname === "/chat"
              ? "bottom-chat-active.svg"
              : "bottom-chat.svg"
          }`}
          alt="채팅"
          className="nav-icon"
        />
      </Link>

      <Link
        to="/mypage"
        className={`nav-item ${
          location.pathname === "/mypage" ? "active" : ""
        }`}
        onClick={() => handleTabChange("mypage", 4)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/${
            location.pathname === "/mypage"
              ? "bottom-mypage-active.svg"
              : "bottom-mypage.svg"
          }`}
          alt="마이 페이지"
          className="nav-icon"
        />
      </Link>
    </div>
  );
};

export default BottomNavigation;
